export default __webpack_public_path__ + "static/media/RP4_KICK_1.72881f4b.mp3";